import React from 'react'
import { withStyles } from '@weareroam/cake-ui-v1/styles'
import withRoot from '../../withRoot'

const styles = theme => ({
    root: {
        display: 'none',
        margin: '40px 10px 0',
        width: 'calc(100% - 20px)',
        backgroundColor: theme.palette.white,
        border: 'none',
        padding: '10px 30px',
        cursor: 'pointer',
        transition: theme.effects.transition.short,

        '&:active': {
            backgroundColor: theme.palette.secondary.main,
            border: 'none',
            outline: 0,
        },
        '&:focus': {
            outline: 0,
        }
    },
    [theme.screens.tablet]: {
        root: {
            display: 'block',
        }
    },
})

class LoginButton extends React.Component {
    render() {
        const { classes } = this.props

        return (
            <button className={classes.root} type="submit">
                Submit
            </button>
        )
    }
}

export default withRoot(withStyles(styles)(LoginButton))



// WEBPACK FOOTER //
// ./src/components/buttons/LoginButton.js